import { template as template_8558c6fdb0be4660bf024570a28646db } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/file-extract';
const { stringify } = JSON;
export default RouteTemplate(template_8558c6fdb0be4660bf024570a28646db(`
  <div
    data-prerender-file-extract
    data-prerender-file-extract-id={{@model.id}}
    data-prerender-file-extract-nonce={{@model.nonce}}
    data-prerender-file-extract-status={{@model.status}}
  >
    <pre>{{stringify @model null 2}}</pre>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
